// extracted by mini-css-extract-plugin
module.exports = {"header__wrapper":"styles_header__wrapper__QhYCN","header":"styles_header__G55yp","header__logo":"styles_header__logo__gPsdJ","header__buttons":"styles_header__buttons__a_l8x"};